'use client';

import { DataTestIdEnum } from '@medprev-web-app/datatestid';
import Image from 'next/image';

import doctorPerson from './assets/persona-medica.png';
import { FormNotifyMe } from './form-notify-me.component';
import { faceToFaceServiceId } from './consts/face-to-face-service-section.const';

import { ContentContainer } from '@/components/ui/content-container.component';
import { getAnalyticsPlugin } from '@/app/(main)/_components/logger/analytics/get-analytics-plugin';
import { AnalyticsEnum } from '@/types/enums/analytics/analytics.enum';

export const FaceToFaceServiceSection = () => {
  const analytics = getAnalyticsPlugin();

  return (
    <section id={faceToFaceServiceId} data-testid={DataTestIdEnum.CITY_FACE_TO_FACE_SERVICE_SECTION}>
      <ContentContainer className="bg-white md:bg-transparent py-6 md:py-0 my-0 md:my-10">
        <div className="flex gap-6">
          <FormNotifyMe
            className="w-full xl:w-3/5"
            onSubmitCallback={(data) => {
              analytics.track(AnalyticsEnum.CLICK_LEAD_PRESENTIAL_SERVICE, {
                termo_aceito: true,
                nome: data.name,
                email: data.email,
                cidade: data.city,
                estado: data.state,
              });
            }}
          />

          <div className="hidden xl:flex items-end justify-center bg-green-300 rounded-3xl w-2/5">
            <Image
              src={doctorPerson}
              alt="Persona médica"
              draggable={false}
              priority
              className="h-[22.625rem] w-fit"
            />
          </div>
        </div>
      </ContentContainer>
    </section>
  );
};
